import React, { Fragment, Component } from "react";

import Slider from "react-slick";

import bg1 from "../../../assets/utils/images/originals/city.png";
import bg2 from "../../../assets/utils/images/originals/citydark.png";
import bg3 from "../../../assets/utils/images/originals/citynights.png";
import * as actions from "../../../reducers/auth/authActions";
import { connect } from "react-redux";

import { Col, Row, Button, Form } from "reactstrap";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = { email: "", password: "" };
    this.submitHandler = this.submitHandler.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
  }

  submitHandler = (event) => {
    event.preventDefault();
    //useMsal().loginRedirect();
    this.props.onAuth(this.state.email, this.state.password);
  };

  changeHandler(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  render() {
    let settings = {
      dots: true,
      infinite: true,
      speed: 700,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      initialSlide: 0,
      autoplay: true,
      adaptiveHeight: true,
    };
    return (
      <Fragment>
        <div className="h-100">
          <Row className="h-100 no-gutters">
            <Col lg="4" className="d-none d-lg-block">
              <div className="slider-light">
                <Slider {...settings}>
                  <div className="h-100 d-flex justify-content-center align-items-center bg-plum-plate">
                    <div
                      className="slide-img-bg"
                      style={{
                        backgroundImage: "url(" + bg1 + ")",
                      }}
                    />
                    {/* <div className="slider-content">
                      <h3>LIDERAZGO</h3>
                      <p>
                        Un líder dirige e influye positivamente en las personas para alcanzar las metas que se
                        propone. Foragro busca marcar una diferencia por medio de nuevas tecnologías y
                        productos diferenciados con el objetivo de proveer un beneficio a nuestros clientes y
                        facilitar el trabajo del agricultor.
                      </p>
                    </div> */}
                  </div>
                  <div className="h-100 d-flex justify-content-center align-items-center bg-premium-dark">
                    <div
                      className="slide-img-bg"
                      style={{
                        backgroundImage: "url(" + bg3 + ")",
                      }}
                    />
                    {/* <div className="slider-content">
                      <h3>Scalable, Modular, Consistent</h3>
                      <p>
                        Easily exclude the components you don't require.
                        Lightweight, consistent Bootstrap based styles across
                        all elements and components
                      </p>
                    </div> */}
                  </div>
                  <div className="h-100 d-flex justify-content-center align-items-center bg-premium-dark">
                    <div
                      className="slide-img-bg opacity-6"
                      style={{
                        backgroundImage: "url(" + bg2 + ")",
                      }}
                    />
                    {/* <div className="slider-content">
                      <h3>MISIÓN</h3>
                      <p>
                        We've included a lot of components that cover almost all
                        use cases for any type of application.
                      </p>
                    </div> */}
                  </div>
                </Slider>
              </div>
            </Col>
            <Col
              lg="8"
              md="12"
              className="h-100 d-flex bg-white justify-content-center align-items-center"
            >
              <Col lg="9" md="10" sm="12" className="mx-auto app-login-box">
                <div className="app-logo" />
                <h4 className="mb-0">
                  <div>Bienvenido de vuelta,</div>
                  <span>Por favor ingrese a su cuenta.</span>
                </h4>

                <div>
                  <Form onSubmit={this.submitHandler}>
                    <Row className="divider" />
                    <div className="justify-content-center">
                      <div className="ml-auto">
                        <Button color="primary" size="lg">
                          Iniciar sesión
                        </Button>
                      </div>
                    </div>
                  </Form>
                </div>
              </Col>
            </Col>
          </Row>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLogin: state.auth.isLogin,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    onAuth: () => dispatch(actions.signIn()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Login);
